import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { useDeviceUISettings } from 'console/shared/contexts/device-ui-settings';
import { useDeviceUISettingsControl } from 'console/shared/contexts/device-ui-settings/control';
import { memo, useMemo } from 'react';
import * as S from './styles';
import { useResizeDetector } from 'react-resize-detector';
import { useSortableGridResize } from 'console/shared/hooks/layout';
const style = { width: '100%', height: '100%' };
export const MediumUISortablePanels = memo(function MediumUISortablePanels(props) {
    const { list } = props;
    const { sorting_mode } = useDeviceUISettings();
    const { onPanelInteractionEnd } = useDeviceUISettingsControl();
    const { width, height, ref } = useResizeDetector({ handleHeight: false });
    const panels = useMemo(() => list.map(({ id, component }) => (_jsx(Box, { height: "100%", width: "100%", children: component }, id))), [list]);
    const layout = useMemo(() => Object.values(list).map(({ ui_settings }) => {
        const { id: i, x, y, height: h, width: w } = ui_settings;
        return {
            i,
            x,
            y,
            w,
            h,
            minH: 4,
            minW: 2,
            isBounded: true,
        };
    }), [list]);
    const layouts = useMemo(() => ({ lg: layout, md: layout, sm: layout, xs: layout, xxs: layout }), [layout]);
    const resize_ref = useSortableGridResize(width);
    return (_jsx("div", { ref: ref, style: style, children: _jsx(S.SortablePanelsGridLayout, { layouts: layouts, autoSize: true, onDragStop: onPanelInteractionEnd, onResizeStop: onPanelInteractionEnd, isResizable: sorting_mode, isDraggable: sorting_mode, useCSSTransforms: true, ref: resize_ref, cols: { lg: 16, md: 16, sm: 16, xs: 16, xxs: 16 }, rowHeight: 24, draggableHandle: ".panel-drag-handle", resizeHandles: ['s', 'w', 'e', 'n', 'sw', 'nw', 'se', 'ne'], className: sorting_mode ? 'sortable-fallback' : undefined, compactType: "vertical", children: panels }) }));
});
